import { Table } from 'antd';
import { useTranslation } from 'react-i18next';

import StyledCard from 'components/styled-card';
import { NightlyResponse } from 'types/hcp/pdfreport.type';
import { formatAHI } from 'utils/hcp/report/report.helper';

import type { ColumnsType } from 'antd/es/table';

interface DataType {
  key: string;
  position: string;
  supine: string;
  prone: string;
  right: string;
  left: string;
  nsupine: string;
}

const PositionStatistics = ({ nightly }: { nightly: NightlyResponse }) => {
  const { t } = useTranslation();

  const columns: ColumnsType<DataType> = [
    {
      title: t('position.p'),
      dataIndex: 'position',
      key: 'position',
    },
    {
      title: t('position.supine'),
      dataIndex: 'supine',
      key: 'supine',
    },
    {
      title: t('position.prone'),
      dataIndex: 'prone',
      key: 'prone',
    },
    {
      title: t('position.right'),
      dataIndex: 'right',
      key: 'right',
    },
    {
      title: t('position.left'),
      dataIndex: 'left',
      key: 'left',
    },
    {
      title: t('position.nsupine'),
      dataIndex: 'nsupine',
      key: 'nsupine',
    },
  ];
  const data: DataType[] = [
    {
      key: '1',
      position: t('sleep'),
      supine: nightly.variables.formattedTSTSupine,
      prone: nightly.variables.formattedTSTProne,
      right: nightly.variables.formattedTSTRight,
      left: nightly.variables.formattedTSTLeft,
      nsupine: nightly.variables.formattedTSTNonsupine,
    },
    {
      key: '2',
      position: `${t('sleep')} %`,
      supine: nightly.variables.PercTSTSupine,
      prone: nightly.variables.PercTSTProne,
      right: nightly.variables.PercTSTRight,
      left: nightly.variables.PercTSTLeft,
      nsupine: nightly.variables.PercTSTNonsupine,
    },
    {
      key: '3',
      position: t('summary.ahi-short'),
      supine: formatAHI(nightly.variables.AHISupine),
      prone: formatAHI(nightly.variables.AHIProne),
      right: formatAHI(nightly.variables.AHIright),
      left: formatAHI(nightly.variables.AHILeft),
      nsupine: formatAHI(nightly.variables.AHInonsupine),
    },
    {
      key: '4',
      position: t('nightly.odi'),
      supine: nightly.variables.ODISupine,
      prone: nightly.variables.ODIProne,
      right: nightly.variables.ODIright,
      left: nightly.variables.ODILeft,
      nsupine: nightly.variables.ODInonsupine,
    },
  ];
  return (
    <StyledCard id="position" title={t('position.label')}>
      <div>
        {nightly.variables.positionalityFail !== 0 ? (
          <p>{t('position.no-data')}</p>
        ) : (
          <Table
            scroll={{ x: 'max-content' }}
            size="middle"
            pagination={false}
            columns={columns}
            dataSource={data}
          />
        )}
      </div>
    </StyledCard>
  );
};

export default PositionStatistics;
